const computeVacationsForEvent = require('./computeVacationForEvent');

module.exports = function (events, startDate, endDate) {
  return events.map(event => ({
    event,
    vacations: computeVacationsForEvent(event, startDate, endDate)
  })).sort((a, b) => a.event.startDate.localeCompare(b.event.startDate));
};